function logEvent(message) {
  document.dispatchEvent(new CustomEvent("game.event", {
    detail: {
      message,
    }
  }));
}

function restAction(entity, detail, stage) {
  const enemies = stage.visibleEntities().filter(en => en.isEnemy());

  if (enemies.length > 0) {
    logEvent("Rested for a turn but can’t heal when monsters are nearby");
    return;
  }

  if (entity.health.hp < entity.health.max) {
    const restedHp = 1 + entity.stats.toughnessModifier;
    const restoreHealth = Math.min(entity.health.hp + restedHp, entity.health.max);
    entity.health.hp = restoreHealth;
    logEvent(`Rested for a turn and restored ${restedHp}`);
  }

  logEvent("Rested for a turn");
}

function getAction(entity, items, stage) {
  // TODO: launch dialog if multiple entities or smarter logic for pickups
  const item = items[items.length - 1];
  if (stage.player.equipment.canAddItem(item)) {
    stage.removeEntity(item);
    item.x = null;
    item.y = null;
    stage.player.equipment.addItem(item);
    logEvent(`Picked up ${item.name}`);
  }
}

function dropAction(entity, detail, stage) {
  const { slot, index } = detail;
  const item = entity.equipment.dropItem(slot, index);

  if (item) {
    stage.spawnEntity(item, entity.x, entity.y);
    logEvent(`Dropped ${item.name}`);
  }
}

function fireAction(entity, target, stage) {
  const targetEntities = stage.entitiesAt(target.x, target.y);

  if (targetEntities.length == 0) {
    logEvent(`${entity.name} fired a shot`);
  }

  for (let occupant of targetEntities) {
    if (occupant.isBlocking()) {
      occupant.shotFrom(entity);
      return;
    }
  }
  entity.consumeShot();
}

function moveAction(entity, direction, stage) {
  const mx = entity.x + direction.x;
  const my = entity.y + direction.y;

  if (stage.canMoveTo(mx, my)) {
    for (let occupant of stage.entitiesAt(mx, my)) {
      if (occupant.isBlocking()) {
        occupant.bumpFrom(entity, stage);
        return;
      }
    }

    stage.moveEntityTo(entity, mx, my);
    stage.refreshVisibility();
  } else if (stage.canInteractWith(mx, my)) {
    // Can only open door tiles for now
    stage.openDoor(mx, my);

    const label = stage.map[my][mx].name
      .replace(/[0-9]/g, "")
      .replace(/([a-z])([A-Z])/g, "$1 $2");

    logEvent(`Opened ${label}`)
  }
}

export {
  getAction,
  dropAction,
  moveAction,
  fireAction,
  restAction
};
